import { useDispatch } from "react-redux";
import { showModal } from "../../../../../../../store/modalSlice";
import { MODAL_ID } from "../../../../../../../utils/constants";

/**
 * @desc Create new convention handler.
 */
export const useHandlers = () => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Show a modal on click.
   */
  const handleClick = () => {
    dispatch(
      showModal({
        id: MODAL_ID.CREATE_NEW_CONVENTION,
      })
    );
  };

  // HOOK ---------------------------------------------------------------------

  return { handleClick };
};

export default useHandlers;
